import queryString from "query-string";

import { setCountryFilterData } from "app/action_types/country_filter_action-types";
import { keywordGroupsTransforms } from "app/services/keyword-groups";
import { apiHelper } from "app/common/services/apiHelper";
import { swSettings } from "app/common/services/swSettings";
import type { transitionHookFn } from "app/routes/handlers/redirectFunctions/redirectPipe";
import { DefaultFetchService } from "app/services/fetchService";
import { SwRedux } from "app/services/SwRedux";

export const onRedirectSerpSnapshot: transitionHookFn = (transition) => {
    return new Promise(async (resolve) => {
        const redux = SwRedux.getInstance();
        const params = { ...transition.params() };
        const paramsChanges = { ...transition.paramsChanged() };
        const countryFilterRedux = redux.getState().countryFilter;
        const countryCode = Number(params.country);
        const isKeywordGroup = keywordGroupsTransforms.isKeywordGroup(params.keyword);

        const shouldFetch =
            (paramsChanges?.duration !== undefined ||
                paramsChanges?.webSource !== undefined ||
                paramsChanges?.keyword !== undefined ||
                countryFilterRedux.countriesData === null) &&
            params.keyword !== undefined;
        if (shouldFetch) {
            const filtered = Object.fromEntries(Object.entries(params).filter(([key, value]) => value));
            const paramsForApi = apiHelper.transformParamsForAPI(filtered);
            paramsForApi.keys = paramsForApi.term;
            const queryStringParams = queryString.stringify(paramsForApi);
            const redirectResult = {
                state: "digitalsuite_keywordAnalysis_serpSnapshot",
                params,
            };
            try {
                const countriesRank = await DefaultFetchService.getInstance().get(
                    `/api/SerpSnapshot/TopCountries?${queryStringParams}`,
                    undefined,
                    {
                        preventAutoCancellation: true,
                    },
                );
                isKeywordGroup
                    ? redux.dispatch(setCountryFilterData(null))
                    : redux.dispatch(setCountryFilterData(countriesRank));
                const asArray = Object.entries(countriesRank as Record<string, number>);
                const asSortedArray = asArray.sort((a, b) => {
                    return a[1] >= b[1] ? -1 : 1;
                });
                if (countryCode === 999) {
                    redirectResult.params.country = Number(asSortedArray[0][0]);
                } else {
                    resolve();
                }
            } catch (e) {
                redirectResult.params.country = swSettings.components.SerpSnapshot.resources.InitialCountry;
            } finally {
                resolve(redirectResult);
            }
        } else {
            resolve();
        }
    });
};
